<template>
  <v-app>
    <v-app-bar app absolute :height="`${$vuetify.breakpoint.mdAndUp ? '88px' : '66px'}`">
      <v-toolbar-title @click="$router.push('/')" style="cursor: pointer">
        <img height="54px" class="pt-1" :src="require('@/assets/logo.svg')">
      </v-toolbar-title>
      <v-toolbar-items v-if="$vuetify.breakpoint.mdAndUp" class="ml-5 align-center">
        <nav-links v-slot="{ links }">
          <div>
            <v-btn
              v-for="link in links"
              :to="link.link"
              :key="link.name"
              text
              class="subtitle-1 font-weight-medium"
              color="primary"
            >{{ link.text }}</v-btn>
          </div>
        </nav-links>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-btn
        v-if="$vuetify.breakpoint.mdAndUp"
        elevation="8"
        hover
        large
        color="primary"
        to="/contact"
      >
        <v-icon left dark>mdi-forum</v-icon>Talk to us
      </v-btn>
      <v-app-bar-nav-icon color="primary" @click="menu = !menu" class="hidden-md-and-up">
        <v-icon large>mdi-menu</v-icon>
      </v-app-bar-nav-icon>
    </v-app-bar>
    <v-slide-y-transition mode="out-in">
      <v-container
        v-show="menu"
        grid-list-xs
        class="primary"
        pa-0
        pb-2
        style="position: absolute; z-index: 1"
      >
        <v-card flat class="transparent">
          <v-app-bar flat color="primary" height="66">
            <v-toolbar-title @click="$router.push('/')" style="cursor: pointer">
              <img height="54px" class="pt-1" :src="require('@/assets/logo-light.svg')">
            </v-toolbar-title>
            <v-toolbar-items v-if="$vuetify.breakpoint.mdAndUp" class="ml-5 align-center">
              <nav-links v-slot="{ links }">
                <div>
                  <v-btn
                    v-for="link in links"
                    :to="link.link"
                    :key="link.name"
                    text
                    class="subtitle-1 font-weight-medium"
                    color="primary"
                  >{{ link.text }}</v-btn>
                </div>
              </nav-links>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-app-bar-nav-icon dark @click="menu = !menu">
              <v-icon large>mdi-close</v-icon>
            </v-app-bar-nav-icon>
          </v-app-bar>

          <nav-links v-slot="{ links }">
            <v-layout row wrap>
              <v-flex xs12 v-for="(link, i) in links" :key="i">
                <v-btn
                  block
                  text
                  large
                  dark
                  color="white"
                  @click="closeAndGo(link.link)"
                >{{ link.text }}</v-btn>
                <v-divider v-if="i + 1 < links.length" dark></v-divider>
              </v-flex>
            </v-layout>
          </nav-links>
        </v-card>
      </v-container>
    </v-slide-y-transition>
    <v-content>
      <v-slide-x-transition mode="out-in">
        <router-view/>
      </v-slide-x-transition>
    </v-content>
  </v-app>
</template>
<script>
import NavLinks from "./components/data/NavLinks";
export default {
  components: {
    NavLinks
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    closeAndGo(link) {
      this.$router.push(link);
      this.menu = false;
    }
  }
};
</script>
